import { Building2 } from "lucide-react";

// Branded "no photo yet" treatment — architectural line art on brand ink.
export default function PhotoFallback({ label = "No photo yet", className = "", testid }) {
  return (
    <div
      data-testid={testid}
      className={`relative h-full w-full bg-brand-ink overflow-hidden flex items-center justify-center ${className}`}
    >
      <svg aria-hidden className="absolute inset-0 h-full w-full opacity-[0.14]" preserveAspectRatio="xMidYMid slice">
        <defs>
          <pattern id="pf-grid" width="28" height="28" patternUnits="userSpaceOnUse">
            <path d="M28 0H0V28" fill="none" stroke="#C5A880" strokeWidth="0.6" />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#pf-grid)" />
        <g stroke="#C5A880" strokeWidth="0.8" fill="none" opacity="0.5">
          <path d="M-20 90 L120 20" />
          <path d="M-20 140 L160 30" />
          <path d="M40 160 L200 40" />
        </g>
      </svg>
      <div className="relative flex flex-col items-center gap-2 text-brand-gold/70">
        <Building2 className="h-7 w-7" strokeWidth={1.25} />
        <span className="text-[10px] uppercase tracking-[0.2em] font-medium">{label}</span>
      </div>
    </div>
  );
}
